// extracted by mini-css-extract-plugin
module.exports = {"imageFigure":"Image_imageFigure__w8nZO","imageFigureCaption":"Image_imageFigureCaption__21Lub","imageFigureLoading":"Image_imageFigureLoading__ExKAh"};